import React, { memo, useEffect } from 'react';
import { Text, useTheme } from 'hoi-poi-ui';
import { Player } from '@lottiefiles/react-lottie-player';
import { sha1FM } from '../../utils';
import { logEvent, identify, logEventBranch } from '../../tracking';
import { createImplementation, checkImplementation } from '../../services';

import RocketGif from './rocketGif.json';

const SignupCreating = memo(({ t, data, onStep, active, referral }) => {
    const theme = useTheme();

    useEffect(() => {
        if (!active || !data) return;
        logEvent({ event: 'signup', functionality: 'rocketUp' });
    }, [active, data]);

    useEffect(() => {
        if (!active || !data) return;

        let apiData = {
            comercials: data.current?.teamSize?.value,
            email: data.current.email,
            language: window.navigator.language,
            jobtitle: data.current?.role?.value,
            phone: `${data.current.phonePrefix}${data.current.phone || ''}`,
            name: data.current.name,
            newsletter: data.current.checks.newsletter || false,
            password: data.current.password,
            privacyPolicy: data.current.checks.privacyAndTermsPolicy,
            termsAndConditions: data.current.checks.privacyAndTermsPolicy,
            type: 'smbtrial',
            coordinates: {
                latitude: data.current.latitude,
                longitude: data.current.longitude,
            },
            implementationName: data.current.companyName,
            timeZoneCode: data.current.timeZone,
        };

        if (referral) apiData.referral = referral;

        let attemps = 0;
        const MAX_ATTEMPS = 50;
        const ATTEMP_INTERVAL = 1500;
        const sessionData = {
            email: data.current.email,
            password: data.current.password,
        };

        const token = data.current.token;

        createImplementation(data.current.token, apiData)
            .then(({ data }) => {
                const interval = setInterval(() => {
                    attemps++;
                    checkImplementation(token, data?.tag)
                        .then(({ data }) => {
                            if (data?.status === 1) {
                                clearInterval(interval);

                                logEvent({ event: 'signup', functionality: 'rocketUpCompleted' });
                                identify(data.userId, data.implementationId);
                                logEventBranch('SIGNUP');

                                const _hsq = (window._hsq = window._hsq || []);
                                if (_hsq) {
                                    _hsq.push([
                                        'identify',
                                        {
                                            email: sessionData.email,
                                        },
                                    ]);
                                    _hsq.push(['trackPageView']);
                                }

                                setTimeout(() => {
                                    window.location =
                                        'https://app.forcemanager.net/?user=' +
                                        encodeURIComponent(sessionData.email) +
                                        '&token=' +
                                        sha1FM(`${sessionData.email}|${sessionData.password}`) +
                                        '#/auth';
                                }, 1000);
                            } else if (data?.error || attemps === MAX_ATTEMPS) {
                                console.error(data?.error);
                                clearInterval(interval);
                                onStep(1);
                            }
                        })
                        .catch((e) => {
                            console.error(e);
                            clearInterval(interval);
                            onStep(1);
                        });
                }, ATTEMP_INTERVAL);
            })
            .catch((e) => {
                console.error(e);
                onStep(1);
            });
    }, [active, data, onStep, referral]);

    return (
        <div className="signup__creating">
            <div className="signup__loading">
                <Text type="h4" color={theme.colors.actionMajor[500]}>
                    {t('label_signup_creating')}
                </Text>
                <Player autoplay loop src={RocketGif}></Player>
            </div>
        </div>
    );
});

export default SignupCreating;
